import { render, staticRenderFns } from "./ResourceSearchInput.vue?vue&type=template&id=33e6f045&scoped=true"
import script from "./ResourceSearchInput.vue?vue&type=script&lang=js"
export * from "./ResourceSearchInput.vue?vue&type=script&lang=js"
import style0 from "./ResourceSearchInput.vue?vue&type=style&index=0&id=33e6f045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6f045",
  null
  
)

export default component.exports